import t from "../../../../utils/translate";

import vial from "../../imgs/vial.png";
import pens from "../../imgs/pens.png";
import clinician from "../../imgs/clinician.png";

const cardData = [
  {
    type: "compound",
    title: t("COMPOUNDED_GLP1_CARD_HEADLINE"),
    subtitle: t("COMPOUNDED_GLP1_CARD_SUBHEADING"),
    text: t("COMPOUNDED_GLP1_CARD_DETAILS"),
    image: vial,
    imageAlt: "",
    pill: t("CARD_FLAG_FASTEST")
  },
  {
    type: "wegovy",
    title: t("CASH_PAY_WEGOVY_CARD_HEADLINE"),
    subtitle: t("CASH_PAY_WEGOVY_CARD_SUBHEADING"),
    text: t("CASH_PAY_WEGOVY_CARD_DETAILS"),
    image: t("CASH_PAY_WEGOVY_CARD_IMAGE"),
    imageAlt: t("CASH_PAY_WEGOVY_CARD_IMAGE_ALT"),
    pill: t("CASH_PAY_WEGOVY_CARD_FLAG")
  },
  {
    type: "insurance",
    title: t("INSURANCE_COVERED_GLP1_CARD_HEADLINE"),
    subtitle: t("INSURANCE_COVERED_GLP1_CARD_SUBHEADING"),
    text: t("INSURANCE_COVERED_GLP1_CARD_DETAILS"),
    image: pens,
    imageAlt: "",
    pill: ""
  },
  {
    type: "clinician",
    title: t("DECIDE_WITH_CLINICIAN_CARD_HEADLINE"),
    subtitle: t("DECIDE_WITH_CLINICIAN_CARD_SUBHEADING"),
    text: "",
    image: clinician,
    imageAlt: "",
    pill: ""
  }
];

export default cardData;
